<template>
  <div class="api-doc-container">
    <div class="api-header">
      <h1 class="api-title">接口1:获取指定时间范围内的焊接记录数据</h1>
      <div class="api-basic-info">
        <div class="info-item">
          <span class="label">接口地址:</span>
          <code class="value">/gw/record/get</code>
        </div>
        <div class="info-item">
          <span class="label">请求方法:</span>
          <span class="value method-get">GET</span>
        </div>
        <div class="info-item">
          <span class="label">协议:</span>
          <span class="value">HTTP</span>
        </div>
        <div class="info-item">
          <span class="label">默认端口:</span>
          <span class="value">8888(随着版本的更新这个值会变化的)</span>
        </div>
      </div>
      <div>请求示例：http://127.0.0.1:8888/gw/record/get?start=1394859684&end=1394859690&filed=data,curve</div>
    </div>

    <div class="api-section">
      <h2 class="section-title">接口描述</h2>
      <div class="section-content">
        <p>获取指定时间范围内的记录详情数据，支持选择返回的数据字段类型。</p>
      </div>
    </div>

    <div class="api-section">
      <h2 class="section-title">请求参数</h2>
      <div class="section-content">
        <h3 class="sub-title">Query 参数</h3>
        <div class="params-table">
          <table>
            <thead>
              <tr>
                <th>参数名</th>
                <th>类型</th>
                <th>必填</th>
                <th>描述</th>
                <th>示例值</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td><code>start</code></td>
                <td>integer</td>
                <td><span class="required">是</span></td>
                <td>开始时间戳（秒级）</td>
                <td><code>1394859684</code></td>
              </tr>
              <tr>
                <td><code>end</code></td>
                <td>integer</td>
                <td><span class="required">是</span></td>
                <td>结束时间戳（秒级）</td>
                <td><code>1394859690</code></td>
              </tr>
              <tr>
                <td><code>filed</code></td>
                <td>string</td>
                <td><span>否</span></td>
                <td>请求的字段类型，多个字段用逗号分隔</td>
                <td><code>默认值为data,可传入值为data/curve或data,curve</code></td>
              </tr>
            </tbody>
          </table>
        </div>

        <div class="param-details">
          <h4 class="param-title">filed 参数说明</h4>
          <ul class="param-list">
            <li><strong>data:</strong> 基础数据记录</li>
            <li><strong>curve:</strong> 曲线数据</li>
          </ul>
        </div>
      </div>
    </div>

    <div class="api-section">
      <h2 class="section-title">响应格式</h2>
      <div class="section-content">
        <div class="response-example">
          <h3 class="sub-title success">成功响应 (HTTP 200)</h3>
          <pre class="code-block"><code>{
  "code": 200,
  "data": {
    "record": [
      {
        "curve": {
          "current": [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
          "press": [9.697, 9.697, 9.697, 9.697, 9.697, 9.697, 9.697, 9.697, 9.697, 9.697, 9.697, 9.697, 9.697, 9.697, 9.697, 9.697, 9.697, 9.697, 9.697, 9.697, 9.697, 9.697, 9.697, 9.697, 9.697, 9.697, 9.697, 9.697, 9.697, 9.697, 9.697, 9.697, 9.697, 9.697, 9.697, 9.697, 9.697, 9.697, 9.697, 9.697, 9.697, 9.697, 9.697, 9.697, 9.697, 9.697, 9.697, 9.697, 9.697, 9.697, 9.697, 9.697, 9.697, 9.697, 9.697, 9.697, 9.697, 9.697, 9.697, 9.697, 9.697, 9.697, 9.697, 9.697, 9.697, 9.697, 9.697, 9.697, 9.697, 9.697, 9.697, 9.697, 9.697, 9.697, 9.697, 9.697, 9.697, 9.697, 9.697, 9.697, 9.697, 9.697, 9.697, 9.697, 9.697, 9.697, 9.697, 9.697, 9.697, 9.697, 9.697, 9.697, 9.697, 9.697, 9.697, 9.697, 9.697, 9.697, 9.697, 9.697, 9.697, 9.697, 9.697, 9.697, 9.697, 9.697, 9.697, 9.697, 9.697, 9.697, 9.697, 9.697, 9.697, 9.697, 9.697, 9.697, 9.697, 9.697, 9.697, 9.697, 9.697, 9.697, 9.697, 9.697, 9.697, 9.697, 9.697, 9.697, 9.697, 9.697, 9.697, 9.697, 9.697, 9.697, 9.697, 9.697, 9.697, 9.697, 9.697, 9.697, 9.697, 9.697, 9.697, 9.697, 9.697, 9.697, 9.697, 9.697, 9.697, 9.697, 9.697, 9.697, 9.697, 9.697, 9.697, 9.697, 9.697, 9.697, 9.697, 9.697, 9.697, 9.697, 9.697, 9.697, 9.697, 9.697, 9.697, 9.697, 9.697, 9.697, 9.697, 9.697, 9.697, 9.697, 9.697, 9.697, 9.697, 9.697, 9.697, 9.697, 9.697, 9.697, 9.697, 9.697, 9.697, 9.697, 9.697, 9.697, 9.697, 9.697, 9.697, 9.697, 9.697, 9.697, 9.697, 9.697, 9.697, 9.697, 9.697, 9.697, 9.697, 9.697, 9.697, 9.697, 9.697, 9.697, 9.697, 9.697, 9.697, 9.697, 9.697, 9.697, 9.697, 9.697, 9.697, 9.697, 9.697, 9.697, 9.697, 9.697, 9.697, 9.697, 9.697, 9.697, 9.697, 9.697, 9.697, 9.697, 9.697, 9.697, 9.697, 9.697, 9.697, 9.697, 9.697, 9.697, 9.697, 9.697, 9.697, 9.697, 9.697, 9.697, 9.697, 9.697, 9.697, 9.697, 9.697, 9.697, 9.697, 9.697, 9.697, 9.697, 9.697, 9.697, 9.697, 9.697, 9.697, 9.697, 9.697, 9.697, 9.697, 9.697, 9.697, 9.697, 9.697, 9.697, 9.697, 9.697, 9.697, 9.697, 9.697, 9.697, 9.697, 9.697, 9.697, 9.697, 9.697, 9.697, 9.697, 9.697, 9.697, 9.697, 9.697, 9.697, 9.697, 9.697, 9.697, 9.697, 9.697, 9.697, 9.697, 9.697, 9.697, 9.697, 9.697, 9.697, 9.697, 9.697, 9.697, 9.697, 9.697, 9.697, 9.697, 9.697, 9.697, 9.697, 9.697, 9.697, 9.697, 9.697, 9.697, 9.697, 9.697, 9.697, 9.697, 9.697, 9.697, 9.697, 9.697, 9.697, 9.697, 9.697, 9.697, 9.697, 9.697, 9.697, 9.697, 9.697, 9.697, 9.697, 9.697, 9.697, 9.697, 9.697, 9.697, 9.697, 9.697, 9.697, 9.697, 9.697, 9.697, 9.697, 9.697, 9.697, 9.697, 9.697, 9.697, 9.697, 9.697, 9.697, 9.697, 9.697, 9.697, 9.697, 9.697, 9.697, 9.697, 9.697, 9.697, 9.697, 9.697, 9.697, 9.697, 9.697, 9.697, 0, 9.701, 9.699, 9.698, 9.697, 9.697, 9.697, 9.697, 9.697, 9.697, 9.697, 9.697, 9.697, 9.697, 9.697, 9.697, 9.697, 9.697, 9.697, 9.697, 9.697, 9.697, 9.697, 9.697, 9.697, 9.697, 9.697, 9.697, 9.697, 9.697, 9.697, 9.697, 9.697, 9.697, 9.697, 9.697, 9.697, 9.697, 9.697, 9.697, 9.697, 9.697, 9.697, 9.697, 9.697, 9.697, 9.697, 9.697, 9.697, 9.697, 9.697, 9.697, 9.697, 9.697, 9.697, 9.697, 9.697, 9.697, 9.697, 9.697, 9.697, 9.697, 9.697, 9.697, 9.697, 9.697, 9.697, 9.697, 9.697, 9.697, 9.697, 9.697, 9.697, 9.697, 9.697, 9.697, 9.697, 9.697, 9.697, 9.697, 9.697, 9.697, 9.697, 9.697, 9.697, 9.697, 9.697, 9.697, 9.697, 9.697, 9.697, 9.697, 9.697, 9.697, 9.697, 9.697, 9.697, 9.697, 9.697, 9.697, 9.697, 9.697, 9.697, 9.697, 9.697, 9.697, 9.697, 9.697, 9.697, 9.697, 9.697, 9.697, 9.697, 9.697, 9.697, 9.697, 9.697, 9.697, 9.697, 9.697, 9.697, 9.697, 9.697, 9.697, 9.697, 9.697, 9.697, 9.697, 9.697, 9.697, 9.697, 9.697, 9.697, 9.697, 9.697, 9.697, 9.697, 9.697, 9.697, 9.697, 9.697, 9.697, 9.697, 9.697, 9.697, 9.697, 9.697, 9.697, 9.697, 9.697, 9.697, 9.697, 9.697, 9.697, 9.697, 9.697, 9.697, 9.697, 9.697, 9.697, 9.697, 9.697, 9.697, 9.697, 9.697, 9.697, 9.697, 9.697, 9.697, 9.697, 9.697, 9.697, 9.697, 9.697, 9.697, 9.697, 9.697, 9.697, 9.697, 9.697, 9.697, 9.697, 9.697, 9.697, 9.697, 9.697, 9.697, 9.697, 9.697, 9.697, 9.697, 9.697, 9.697, 9.697, 9.697, 9.697, 9.697, 9.697, 9.697, 9.697, 9.697, 9.697, 9.697, 9.697, 9.697, 9.697, 9.697, 9.697, 9.697, 9.697, 9.697, 9.697, 9.697, 9.697, 9.697, 9.697, 9.697, 9.697, 9.697, 9.697, 9.697, 9.697, 9.697, 9.697, 9.697, 9.697, 9.697, 9.697, 9.697, 9.697, 9.697, 9.697, 9.697, 9.697, 9.697, 9.697, 9.697, 9.697, 9.697, 9.697, 9.697, 9.697, 9.697, 9.697, 9.697, 9.697, 9.697, 9.697, 9.697, 9.697, 9.697, 9.697, 9.697, 9.697, 9.697, 9.697, 9.697, 9.697, 9.697, 9.697, 9.697, 9.697, 9.697, 9.697, 9.697, 9.697, 9.697, 9.697, 9.697, 9.697, 9.697, 9.697, 9.697, 9.697, 9.697, 9.697, 9.697, 9.697, 9.697, 9.697, 9.697, 9.697, 9.697, 9.697, 9.697, 9.697, 9.697, 9.697, 9.697, 9.697, 9.697, 9.697, 9.697, 9.697, 9.697, 9.697, 9.697, 9.697, 9.697, 9.697, 9.697, 9.697, 9.697, 9.697, 9.697],
          "resistance": [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
          "voltage": [9.697, 9.697, 9.697, 9.697, 9.697, 9.697, 9.697, 9.697, 9.697, 9.697, 9.697, 9.697, 9.697, 9.697, 9.697, 9.697, 9.697, 9.697, 9.697, 9.697, 9.697, 9.697, 9.697, 9.697, 9.697, 9.697, 9.697, 9.697, 9.697, 9.697, 9.697, 9.697, 9.697, 9.697, 9.697, 9.697, 9.697, 9.697, 9.697, 9.697, 9.697, 9.697, 9.697, 9.697, 9.697, 9.697, 9.697, 9.697, 9.697, 9.697, 9.697, 9.697, 9.697, 9.697, 9.697, 9.697, 9.697, 9.697, 9.697, 9.697, 0, 9.701, 9.699, 9.698, 9.697, 9.697, 9.697, 9.697, 9.697, 9.697, 9.697, 9.697, 9.697, 9.697, 9.697, 9.697, 9.697, 9.697, 9.697, 9.697, 9.697, 9.697, 9.697, 9.697, 9.697, 9.697, 9.697, 9.697, 9.697, 9.697, 9.697, 9.697, 9.697, 9.697, 9.697, 9.697, 9.697, 9.697, 9.697, 9.697, 9.697, 9.697, 9.697, 9.697, 9.697, 9.697, 9.697, 9.697, 9.697, 9.697, 9.697, 9.697, 9.697, 9.697, 9.697, 9.697, 9.697, 9.697, 9.697, 9.697, 9.697, 9.697, 9.697, 9.697, 9.697, 9.697, 9.697, 9.697, 9.697, 9.697, 9.697, 9.697, 9.697, 9.697, 9.697, 9.697, 9.697, 9.697, 9.697, 9.697, 9.697, 9.697, 9.697, 9.697, 9.697, 9.697, 9.697, 9.697, 9.697, 9.697, 9.697, 9.697, 9.697, 9.697, 9.697, 9.697, 9.697, 9.697, 9.697, 9.697, 9.697, 9.697, 9.697, 9.697, 9.697, 9.697, 9.697, 9.697, 9.697, 9.697, 9.697, 9.697, 9.697, 9.697, 9.697, 9.697, 9.697, 9.697, 9.697, 9.697, 9.697, 9.697, 9.697, 9.697, 9.697, 9.697, 9.697, 9.697, 9.697, 9.697, 9.697, 9.697, 9.697, 9.697, 9.697, 9.697, 9.697, 9.697, 9.697, 9.697, 9.697, 9.697, 9.697, 9.697, 9.697, 9.697, 9.697, 9.697, 9.697, 9.697, 9.697, 9.697, 9.697, 9.697, 9.697, 9.697, 9.697, 9.697, 9.697, 9.697, 9.697, 9.697, 9.697, 9.697, 9.697, 9.697, 9.697, 9.697, 9.697, 9.697, 9.697, 9.697, 9.697, 9.697, 9.697, 9.697, 9.697, 9.697, 9.697, 9.697, 9.697, 9.697, 9.697, 9.697, 9.697, 9.697, 9.697, 9.697, 9.697, 9.697, 9.697, 9.697, 9.697, 9.697, 9.697, 9.697, 9.697, 9.697, 9.697, 9.697, 9.697, 9.697, 9.697, 9.697, 9.697, 9.697, 9.697, 9.697, 9.697, 9.697, 9.697, 9.697, 9.697, 9.697, 9.697, 9.697, 9.697, 9.697, 9.697, 9.697, 9.697, 9.697, 9.697, 9.697, 9.697, 9.697, 9.697, 9.697, 9.697, 9.697, 9.697, 9.697, 9.697, 9.697, 9.697, 9.697, 9.697, 9.697, 9.697, 9.697, 9.697, 9.697, 9.697, 9.697, 9.697, 9.697, 9.697, 9.697, 9.697, 9.697, 9.697, 9.697, 9.697, 9.697, 9.697, 9.697, 9.697, 9.697, 9.697, 9.697, 9.697, 9.697, 9.697, 9.697, 9.697, 9.697, 9.697, 9.697, 9.697, 9.697, 9.697, 9.697, 9.697, 9.697, 9.697, 9.697, 9.697, 9.697, 9.697, 9.697, 9.697, 9.697, 9.697, 9.697, 9.697, 9.697, 9.697, 9.697, 9.697, 9.697, 9.697, 9.697, 9.697, 9.697, 9.697, 9.697, 9.697, 9.697, 9.697, 9.697, 9.697, 9.697, 9.697, 9.697, 9.697, 9.697, 9.697, 9.697, 9.697, 9.697, 9.697, 9.697, 9.697, 9.697, 9.697, 9.697, 9.697, 9.697, 9.697, 9.697, 9.697, 9.697, 9.697, 9.697, 9.697, 9.697, 9.697, 9.697, 9.697, 9.697, 9.697, 9.697, 9.697, 9.697, 9.697, 9.697, 9.697, 9.697, 9.697, 9.697, 9.697, 9.697, 9.697, 9.697, 9.697, 9.697, 9.697, 9.697, 9.697, 9.697, 9.697, 9.697, 9.697, 9.697, 9.697, 9.697, 9.697, 9.697, 9.697, 9.697, 9.697, 9.697, 9.697, 9.697, 9.697, 9.697, 9.697, 9.697, 9.697, 9.697, 9.697, 9.697, 9.697, 9.697, 9.697, 9.697, 9.697, 9.697, 9.697, 9.697, 9.697, 9.697, 9.697, 9.697, 9.697, 9.697, 9.697, 9.697, 9.697, 9.697, 9.697, 9.697, 9.697, 9.697, 9.697, 9.697, 9.697, 9.697, 9.697, 9.697, 9.697, 9.697, 9.697, 9.697, 9.697, 9.697, 9.697, 9.697, 9.697, 9.697, 9.697, 9.697, 9.697, 9.697, 9.697, 9.697, 9.697, 9.697, 9.697, 9.697, 9.697, 9.697, 9.697, 9.697, 9.697, 9.697, 9.697, 9.697, 9.697, 9.697, 9.697, 9.697, 9.697, 9.697, 9.697, 9.697, 9.697, 9.697, 9.697, 9.697, 9.697, 9.697, 9.697, 9.697, 9.697, 9.697, 9.697, 9.697, 9.697, 9.697, 9.697, 9.697, 9.697, 9.697, 9.697, 9.697, 9.697, 9.697, 9.697, 9.697, 9.697, 9.697, 9.697, 9.697, 9.697, 9.697, 9.697, 9.697, 9.697, 9.697, 9.697, 9.697, 9.697, 9.697, 9.697, 9.697, 9.697, 9.697, 9.697, 9.697, 9.697, 9.697, 9.697, 9.697, 9.697, 9.697, 9.697, 9.697, 9.697, 9.697, 9.697, 9.697, 9.697, 9.697, 9.697, 9.697, 9.697, 9.697, 9.697, 9.697, 9.697, 9.697, 9.697, 9.697, 9.697, 9.697, 9.697, 9.697, 9.697, 9.697, 9.697, 9.697, 9.697, 9.697, 9.697, 9.697, 9.697, 9.697, 9.697, 9.697, 9.697, 9.697, 9.697, 9.697, 9.697, 9.697, 9.697, 9.697, 9.697, 9.697, 9.697, 9.697, 9.697, 9.697, 9.697, 9.697, 9.697, 9.697, 9.697, 9.697, 9.697, 9.697, 9.697, 9.697, 9.697, 9.697, 9.697, 9.697, 9.697, 9.697, 9.697, 9.697, 9.697, 9.697, 9.697, 9.697, 9.697, 9.697, 9.697, 9.697, 9.697, 9.697, 9.697, 9.697, 9.697, 9.697, 9.697, 9.697, 9.697, 9.697, 9.697, 9.697, 9.697, 9.697, 9.697, 9.697, 9.697, 9.697, 9.697, 9.697, 9.697, 9.697, 9.697, 9.697, 9.697, 9.697, 9.697, 9.697, 9.697, 9.697, 9.697, 9.697, 9.697, 9.697, 9.697, 9.697, 9.697, 9.697, 9.697, 9.697, 9.697, 9.697, 9.697, 9.697, 9.697, 9.697, 9.697, 9.697, 9.697, 9.697, 9.697, 9.697, 9.697, 9.697, 9.697, 9.697, 9.697, 9.697, 9.697, 9.697, 9.697, 9.697, 9.697, 9.697, 9.697, 9.697, 9.697, 9.697, 9.697, 9.697, 9.697, 9.697, 9.697, 9.697, 9.697, 9.697, 9.697, 9.697, 9.697, 9.697, 9.697, 9.697, 9.697, 9.697, 9.697, 9.697, 9.697, 9.697, 9.697, 9.697, 9.697, 9.697, 9.697, 9.697, 9.697, 9.697, 9.697, 9.697, 9.697, 9.697, 9.697, 9.697, 9.697, 9.697, 9.697, 9.697, 9.697, 9.697, 9.697, 9.697, 9.697, 9.697, 9.697, 9.697, 9.697, 9.697, 9.697, 9.697, 9.697, 9.697, 9.697, 9.697, 9.697, 9.697, 9.697, 9.697, 9.697, 9.697, 9.697, 9.697, 9.697, 9.697, 9.697, 9.697, 9.697, 9.697, 9.697, 9.697, 9.697, 9.697, 9.697, 9.697, 9.697, 9.697, 9.697, 9.697, 9.697, 9.697, 9.697, 9.697, 9.697, 9.697, 9.697, 9.697, 9.697, 9.697, 9.697, 9.697, 9.697, 9.697, 9.697, 9.697, 9.697, 9.697, 9.697, 9.697, 9.697, 9.697, 9.697, 9.697, 9.697, 9.697, 9.697, 9.697, 9.697, 9.697, 9.697, 9.697, 9.697, 9.697, 9.697, 9.697, 9.697, 9.697, 9.697, 9.697, 9.697, 9.697, 9.697, 9.697, 9.697, 9.697, 9.697, 9.697, 9.697, 9.697, 9.697, 9.697, 9.697, 9.697, 9.697, 9.697, 9.697, 9.697, 9.697, 9.697, 9.697, 9.697, 9.697, 9.697, 9.697, 9.697, 9.697, 9.697, 9.697, 9.697, 9.697, 9.697, 9.697, 9.697, 9.697, 9.697, 9.697, 9.697, 9.697, 9.697, 9.697, 9.697, 9.697, 9.697, 9.697, 9.697, 9.697, 9.697, 9.697, 9.697, 9.697, 9.697, 9.697, 9.697, 9.697, 9.697, 9.697, 9.697, 9.697, 9.697, 9.697, 9.697, 9.697, 9.697, 9.697, 9.697, 9.697, 9.697, 9.697, 9.697, 9.697, 9.697, 9.697, 9.697, 9.697, 9.697, 9.697, 9.697, 9.697, 9.697, 9.697, 9.697, 9.697, 9.697, 9.697, 9.697, 9.697, 9.697, 9.697, 9.697, 9.697, 9.697, 9.697, 9.697, 9.697, 9.697, 9.697, 9.697, 9.697, 9.697, 9.697, 9.697, 9.697, 9.697, 9.697, 9.697, 9.697, 9.697, 9.697, 9.697, 9.697, 9.697, 9.697, 9.697, 9.697, 9.697, 9.697, 9.697, 9.697, 9.697, 9.697, 9.697, 9.697, 9.697, 9.697, 9.697, 9.697, 9.697, 9.697, 9.697, 9.697, 9.697, 9.697, 9.697, 9.697, 9.697, 9.697, 9.697, 9.697, 9.697, 9.697, 9.697, 9.697, 9.697, 9.697, 9.697, 9.697, 9.697, 9.697, 9.697, 9.697, 9.697, 9.697, 9.697, 9.697, 9.697, 9.697, 9.697, 9.697]
        },
        "data": {
          "RecordId": "43c3909114c844caa3e725511935d43b",
          "AlarmCnt": 48,
          "BatchNumber": "batchNumber",
          "CofStepGrow": 24,
          "CrrPostWeld": 20,
          "CrrPreWeld": 6,
          "CrrWeld1": 10,
          "CrrWeld2": 13,
          "CrrWeld3": 16,
          "DispRsv10": 43,
          "MacId": 1,
          "NoGun2WeldProgram": 39,
          "NoWeldProgram": 1,
          "NumCurrSpot": 26,
          "NumErrRecordNum": 40,
          "NumRepeatWeld": 25,
          "PartName": "partName",          
          "SpotId": 2.8347928374934533e+18,
          "SpotModel": "model",
          "SpotName": "信息",
          "SpotPss": 49,
          "SpotThk": 1,
          "TimAscentWeld": 9,
          "TimCold0": 8,
          "TimCold1": 12,
          "TimCold2": 15,
          "TimCold3": 19,
          "TimCurrentPhase": 3,
          "TimDescendWeld": 18,
          "TimKeep": 22,
          "TimMorePress": 5000,
          "TimPostWeld": 21,
          "TimPrePress": 4,
          "TimPreWeld": 7,
          "TimRelease": 23,
          "TimWeld1": 11,
          "TimWeld2": 14,
          "TimWeld3": 17,
          "ValCurrentGun": 41,
          "ValCurrentPhase": 2,
          "ValDutyOnTime": 44,
          "ValGun1DressedNumCnt": 37,
          "ValGun1ScheduleProdMfgCnt": 29,
          "ValGun1SingleProdSpotCnt": 26,
          "ValGun1StepIncNumCnt": 35,
          "ValGun1TotalProdMfgCnt": 31,
          "ValGun1TotalProdSpotCnt": 0,
          "ValGun2DressedNumCnt": 38,
          "ValGun2ScheduleProdMfgCnt": 30,
          "ValGun2SingleProdSpotCnt": 28,
          "ValGun2StepIncNumCnt": 36,
          "ValGun2TotalProdMfgCnt": 32,
          "ValGun2TotalProdSpotCnt": 34,
          "ValInputStatus": 13695233,
          "ValOperateMode": 1,
          "ValOutputStatus": 524449,
          "ValPowerCnt": 42,
          "ValPrgExpulsionCnt": 45,
          "ValPrimCapVolt": 580,
          "ValSecRest": 47,
          "ValSecVolt": 2.07,
          "ValSysExpulsionCnt": 46,
          "Vin": "vin",
          "WeldProgram": "规范0",
          "Worker": "workder",
          "created_at": "2025-10-22 08:10:40"
        }
      }
    ]
  },
  "msg": "success"
}</code></pre>
        </div>

        <div class="response-example">
          <h3 class="sub-title error">错误响应</h3>
          <pre class="code-block"><code>{
  "code": 24224,
  "message": "start参数缺失",
  "data": null
}</code></pre>
        </div>
      </div>
    </div>

    <div class="api-section">
      <h2 class="section-title">响应字段说明</h2>
      <div class="section-content">
        <h3 class="sub-title">curve 字段说明</h3>
        <div class="params-table">
          <table>
            <thead>
              <tr>
                <th>字段名</th>
                <th>类型</th>
                <th>描述</th>
                <th>示例值</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td><code>current</code></td>
                <td>array</td>
                <td>焊接电流曲线数据数组</td>
                <td><code>[0, 0, 0, 0, ...]</code></td>
              </tr>
              <tr>
                <td><code>press</code></td>
                <td>array</td>
                <td>焊接压力曲线数据数组</td>
                <td><code>[9.697, 9.697, 9.697, ...]</code></td>
              </tr>
              <tr>
                <td><code>resistance</code></td>
                <td>array</td>
                <td>焊接电阻曲线数据数组</td>
                <td><code>[0, 0, 0, 0, ...]</code></td>
              </tr>
              <tr>
                <td><code>voltage</code></td>
                <td>array</td>
                <td>焊接电压曲线数据数组</td>
                <td><code>[9.697, 9.697, 9.697, ...]</code></td>
              </tr>
            </tbody>
          </table>
        </div>

        <h3 class="sub-title">data 字段说明</h3>
        <div class="params-table">
          <table>
            <thead>
              <tr>
                <th>字段名</th>
                <th>类型</th>
                <th>描述</th>
                <th>示例值</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td><code>RecordId</code></td>
                <td>string</td>
                <td>记录唯一标识符</td>
                <td><code>"43c3909114c844caa3e725511935d43b"</code></td>
              </tr>
              <tr>
                <td><code>Vin</code></td>
                <td>string</td>
                <td>车辆vin</td>
                <td><code>"xxx-s"</code></td>
              </tr>
              <tr>
                <td><code>PartName</code></td>
                <td>string</td>
                <td>零件名称</td>
                <td><code>"xxx"</code></td>
              </tr>
              <tr>
                <td><code>BatchNumber</code></td>
                <td>string</td>
                <td>生产批号</td>
                <td><code>"xxx"</code></td>
              </tr>
              <tr>
                <td><code>Worker</code></td>
                <td>string</td>
                <td>操作员</td>
                <td><code>"xxx"</code></td>
              </tr>
              <tr>
                <td><code>MacId</code></td>
                <td>integer</td>
                <td>设备ID</td>
                <td><code>1</code></td>
              </tr>
              <tr>
                <td><code>WeldProgram</code></td>
                <td>string</td>
                <td>规范名</td>
                <td><code>"规范0"</code></td>
              </tr>
              <tr>
                <td><code>NoWeldProgram</code></td>
                <td>integer</td>
                <td>规范号</td>
                <td><code>0</code></td>
              </tr>
              <tr>
                <td><code>ValCurrentPhase</code></td>
                <td>integer</td>
                <td>当前工作阶段</td>
                <td><code>0</code></td>
              </tr>
              <tr>
                <td><code>TimCurrentPhase</code></td>
                <td>integer</td>
                <td>当前阶段运行时间</td>
                <td><code>0</code></td>
              </tr>
              <tr>
                <td><code>TimPrePress</code></td>
                <td>integer</td>
                <td>预压时间</td>
                <td><code>4</code></td>
              </tr>
              <tr>
                <td><code>TimMorePress</code></td>
                <td>integer</td>
                <td>追压时间</td>
                <td><code>4</code></td>
              </tr>
              <tr>
                <td><code>CrrPreWeld</code></td>
                <td>number</td>
                <td>预焊电流</td>
                <td><code>6.1</code></td>
              </tr>
              <tr>
                <td><code>TimPreWeld</code></td>
                <td>integer</td>
                <td>预焊时间</td>
                <td><code>7</code></td>
              </tr>
              <tr>
                <td><code>TimCold0</code></td>
                <td>integer</td>
                <td>冷却时间0</td>
                <td><code>7</code></td>
              </tr>
              <tr>
                <td><code>TimAscentWeld</code></td>
                <td>integer</td>
                <td>缓升时间</td>
                <td><code>7</code></td>
              </tr>
              <tr>
                <td><code>CrrWeld1</code></td>
                <td>number</td>
                <td>焊1电流</td>
                <td><code>10.1</code></td>
              </tr>
              <tr>
                <td><code>TimWeld1</code></td>
                <td>integer</td>
                <td>焊1时间</td>
                <td><code>11</code></td>
              </tr>
              <tr>
                <td><code>TimCold1</code></td>
                <td>integer</td>
                <td>冷却时间1</td>
                <td><code>11</code></td>
              </tr>
              <tr>
                <td><code>CrrWeld2</code></td>
                <td>number</td>
                <td>焊2电流</td>
                <td><code>13.2</code></td>
              </tr>
              <tr>
                <td><code>TimWeld2</code></td>
                <td>integer</td>
                <td>焊2时间</td>
                <td><code>14</code></td>
              </tr>
              <tr>
                <td><code>TimCold2</code></td>
                <td>integer</td>
                <td>冷却时间2</td>
                <td><code>14</code></td>
              </tr>
              <tr>
                <td><code>CrrWeld3</code></td>
                <td>number</td>
                <td>焊3电流</td>
                <td><code>16.2</code></td>
              </tr>
              <tr>
                <td><code>TimWeld3</code></td>
                <td>integer</td>
                <td>焊3时间</td>
                <td><code>17</code></td>
              </tr>
              <tr>
                <td><code>TimDescendWeld</code></td>
                <td>integer</td>
                <td>缓降时间</td>
                <td><code>17</code></td>
              </tr>
              <tr>
                <td><code>TimCold3</code></td>
                <td>integer</td>
                <td>冷却时间3</td>
                <td><code>17</code></td>
              </tr>
              <tr>
                <td><code>CrrPostWeld</code></td>
                <td>number</td>
                <td>后焊电流</td>
                <td><code>20.1</code></td>
              </tr>
              <tr>
                <td><code>TimPostWeld</code></td>
                <td>integer</td>
                <td>后焊时间</td>
                <td><code>21</code></td>
              </tr>
              <tr>
                <td><code>TimKeep</code></td>
                <td>integer</td>
                <td>保持时间</td>
                <td><code>21</code></td>
              </tr>
              <tr>
                <td><code>TimRelease</code></td>
                <td>integer</td>
                <td>休止时间</td>
                <td><code>21</code></td>
              </tr>
              <tr>
                <td><code>CofStepGrow</code></td>
                <td>integer</td>
                <td>步增系数</td>
                <td><code>21</code></td>
              </tr>
              <tr>
                <td><code>NumRepeatWeld</code></td>
                <td>integer</td>
                <td>补焊次数</td>
                <td><code>21</code></td>
              </tr>
              <tr>
                <td><code>NumCurrSpot</code></td>
                <td>integer</td>
                <td>当前焊点计数</td>
                <td><code>21</code></td>
              </tr>
              <tr>
                <td><code>ValPrimCapVolt</code></td>
                <td>integer</td>
                <td>初级电容电压</td>
                <td><code>2</code></td>
              </tr>
              <tr>
                <td><code>ValInputStatus</code></td>
                <td>bit</td>
                <td>输入口状态</td>
                <td><code>24</code></td>
              </tr>
              <tr>
                <td><code>ValOutputStatus</code></td>
                <td>bit</td>
                <td>输出口状态</td>
                <td><code>456</code></td>
              </tr>
              <tr>
                <td><code>ValOperateMode</code></td>
                <td>integer</td>
                <td>系统当前工作模式</td>
                <td><code>1</code></td>
              </tr>
              <tr>
                <td><code>ValGun1SingleProdSpotCnt</code></td>
                <td>integer</td>
                <td>焊钳1单件焊点计数值</td>
                <td><code>4</code></td>
              </tr>
              <tr>
                <td><code>ValGun2SingleProdSpotCnt</code></td>
                <td>integer</td>
                <td>焊钳2单件焊点计数值</td>
                <td><code>5</code></td>
              </tr>
              <tr>
                <td><code>ValGun1ScheduleProdMfgCnt</code></td>
                <td>integer</td>
                <td>焊钳1班产量生产计数值</td>
                <td><code>86</code></td>
              </tr>
              <tr>
                <td><code>ValGun2ScheduleProdMfgCnt</code></td>
                <td>integer</td>
                <td>焊钳1班产量生产计数值</td>
                <td><code>67</code></td>
              </tr>
              <tr>
                <td><code>ValGun1TotalProdMfgCnt</code></td>
                <td>integer</td>
                <td>焊钳1总生产计数值</td>
                <td><code>44</code></td>
              </tr>
              <tr>
                <td><code>ValGun2TotalProdMfgCnt</code></td>
                <td>integer</td>
                <td>焊钳2总生产计数值</td>
                <td><code>12</code></td>
              </tr>
              <tr>
                <td><code>ValGun1TotalProdSpotCnt</code></td>
                <td>integer</td>
                <td>焊钳1总焊点生产计数值</td>
                <td><code>31</code></td>
              </tr>
              <tr>
                <td><code>ValGun2TotalProdSpotCnt</code></td>
                <td>integer</td>
                <td>焊钳2总焊点生产计数值</td>
                <td><code>454</code></td>
              </tr>
              <tr>
                <td><code>ValGun1StepIncNumCnt</code></td>
                <td>integer</td>
                <td>焊钳1步增级数计数值</td>
                <td><code>1</code></td>
              </tr>
              <tr>
                <td><code>ValGun2StepIncNumCnt</code></td>
                <td>integer</td>
                <td>焊钳2步增级数计数值</td>
                <td><code>1</code></td>
              </tr>
              <tr>
                <td><code>ValGun1DressedNumCnt</code></td>
                <td>integer</td>
                <td>焊钳1修磨次数计数值</td>
                <td><code>1</code></td>
              </tr>
              <tr>
                <td><code>ValGun2DressedNumCnt</code></td>
                <td>integer</td>
                <td>焊钳2修磨次数计数值</td>
                <td><code>1</code></td>
              </tr>
              <tr>
                <td><code>NoGun2WeldProgram</code></td>
                <td>integer</td>
                <td>焊钳2当前使用规范号</td>
                <td><code>1</code></td>
              </tr>
              <tr>
                <td><code>NumErrRecordNum</code></td>
                <td>integer</td>
                <td>历史报警记录条数</td>
                <td><code>1</code></td>
              </tr>
              <tr>
                <td><code>ValCurrentGun</code></td>
                <td>integer</td>
                <td>当前使用焊钳号</td>
                <td><code>1</code></td>
              </tr>
              <tr>
                <td><code>ValPowerCnt</code></td>
                <td>number</td>
                <td>能量</td>
                <td><code>1.2</code></td>
              </tr>
              <tr>
                <td><code>DispRsv10</code></td>
                <td>integer</td>
                <td>UIP值</td>
                <td><code>1</code></td>
              </tr>
              <tr>
                <td><code>ValDutyOnTime</code></td>
                <td>integer</td>
                <td>负载能力</td>
                <td><code>1</code></td>
              </tr>

              <tr>
                <td><code>ValPrgExpulsionCnt</code></td>
                <td>integer</td>
                <td>当前规范飞溅计数值</td>
                <td><code>1</code></td>
              </tr>
              <tr>
                <td><code>ValSysExpulsionCnt</code></td>
                <td>integer</td>
                <td>总飞溅计数值</td>
                <td><code>1</code></td>
              </tr>
              <tr>
                <td><code>ValSecVolt</code></td>
                <td>number</td>
                <td>次级电压</td>
                <td><code>1.2</code></td>
              </tr>
              <tr>
                <td><code>ValSecRest</code></td>
                <td>integer</td>
                <td>次级电阻</td>
                <td><code>1</code></td>
              </tr>
              <tr>
                <td><code>AlarmCnt</code></td>
                <td>integer</td>
                <td>报警数</td>
                <td><code>48</code></td>
              </tr>
              <tr>
                <td><code>SpotId</code></td>
                <td>number</td>
                <td>焊点编号</td>
                <td><code>28347928374934533e</code></td>
              </tr>
              <tr>
                <td><code>SpotModel</code></td>
                <td>string</td>
                <td>车型</td>
                <td><code>"model"</code></td>
              </tr>
              <tr>
                <td><code>SpotName</code></td>
                <td>string</td>
                <td>焊点信息</td>
                <td><code>"信息"</code></td>
              </tr>
              <tr>
                <td><code>SpotPss</code></td>
                <td>integer</td>
                <td>压力</td>
                <td><code>1</code></td>
              </tr>
              <tr>
                <td><code>SpotThk</code></td>
                <td>number</td>
                <td>板厚</td>
                <td><code>1.2</code></td>
              </tr>
              <tr>
                <td><code>created_at</code></td>
                <td>string</td>
                <td>创建时间</td>
                <td><code>"2025-10-22 08:10:40"</code></td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>

    <div class="api-section">
      <h2 class="section-title">错误码说明</h2>
      <div class="section-content">
        <div class="error-table">
          <table>
            <thead>
              <tr>
                <th>错误码</th>
                <th>描述</th>
                <th>解决方案</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td><code>200</code></td>
                <td>成功</td>
                <td>-</td>
              </tr>
              <tr>
                <td><code>24223</code></td>
                <td>start入参不正确</td>
                <td>检查请求参数格式和类型</td>
              </tr>
              <tr>
                <td><code>24224</code></td>
                <td>end入参不正确</td>
                <td>检查请求参数格式和类型</td>
              </tr>
              <tr>
                <td><code>24203</code></td>
                <td>查询数据库数据出错</td>
                <td>尝试缩小查询时间范围及字段 </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'DocIndex',
  components: {},
  props: {},
  data() {
    return {}
  },
  computed: {},
  mounted() { },
  created() { },
  methods: {}
}
</script>

<style scoped>
.api-doc-container {
  max-width: 1200px;
  margin: 0 auto;
  padding: 24px;
  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif;
  line-height: 1.6;
  color: #333;
}

.api-header {
  background: #f8f9fa;
  border-radius: 8px;
  padding: 24px;
  margin-bottom: 32px;
  border-left: 4px solid #1890ff;
}

.api-title {
  margin: 0 0 16px 0;
  font-size: 28px;
  font-weight: 600;
  color: #1f2937;
}

.api-basic-info {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));
  gap: 16px;
}

.info-item {
  display: flex;
  align-items: center;
  gap: 8px;
}

.label {
  font-weight: 500;
  color: #6b7280;
  min-width: 80px;
}

.value {
  font-weight: 500;
}

.method-get {
  background: #10b981;
  color: white;
  padding: 2px 8px;
  border-radius: 4px;
  font-size: 12px;
  font-weight: 600;
}

.auth-required {
  color: #ef4444;
  font-weight: 600;
}

.api-section {
  margin-bottom: 32px;
  background: white;
  border-radius: 8px;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
  overflow: hidden;
}

.section-title {
  background: #f8f9fa;
  margin: 0;
  padding: 16px 24px;
  font-size: 20px;
  font-weight: 600;
  border-bottom: 1px solid #e5e7eb;
  color: #1f2937;
}

.section-content {
  padding: 24px;
}

.sub-title {
  margin: 0 0 16px 0;
  font-size: 16px;
  font-weight: 600;
  color: #374151;
}

.sub-title.success {
  color: #10b981;
}

.sub-title.error {
  color: #ef4444;
}

.params-table,
.error-table {
  overflow-x: auto;
  margin-bottom: 24px;
}

table {
  width: 100%;
  border-collapse: collapse;
  font-size: 14px;
}

th {
  background: #f8f9fa;
  padding: 12px 16px;
  text-align: left;
  font-weight: 600;
  color: #374151;
  border-bottom: 1px solid #e5e7eb;
}

td {
  padding: 12px 16px;
  border-bottom: 1px solid #f3f4f6;
}

.required {
  color: #ef4444;
  font-weight: 600;
}

.param-details {
  background: #f8f9fa;
  padding: 16px;
  border-radius: 6px;
  margin-top: 16px;
}

.param-title {
  margin: 0 0 12px 0;
  font-size: 14px;
  font-weight: 600;
  color: #374151;
}

.param-list {
  margin: 0;
  padding-left: 20px;
}

.param-list li {
  margin-bottom: 8px;
}

.response-example {
  margin-bottom: 24px;
}

.code-block {
  background: #1f2937;
  color: #e5e7eb;
  padding: 20px;
  border-radius: 6px;
  overflow-x: auto;
  font-family: 'Monaco', 'Menlo', 'Ubuntu Mono', monospace;
  font-size: 13px;
  line-height: 1.5;
}

.code-block code {
  background: none;
  padding: 0;
  color: inherit;
}

/* 响应式设计 */
@media (max-width: 768px) {
  .api-doc-container {
    padding: 16px;
  }

  .api-basic-info {
    grid-template-columns: 1fr;
  }

  .section-content {
    padding: 16px;
  }

  th,
  td {
    padding: 8px 12px;
  }

  .code-block {
    padding: 16px;
    font-size: 12px;
  }
}
</style>
